// @flow

import React from 'react';
import styled, { css } from 'styled-components';

import Link from './Link';
import type { LinkProps } from './Link';
import { RightSquaredArrow } from 'components/Svg';
import { Color, hoverChild, inlineFlex, p12 } from 'styles';
import { LIGHT_DARK } from 'Constants';
import type { LightDark } from 'Constants';

const Wrapper = styled.div`
  display: inline-block;
  margin-right: 24px;
  &:last-of-type {
    margin-right: 0;
  }
  ${({ theme }) => {
    if (theme === LIGHT_DARK.LIGHT)
      return css`
        ${hoverChild('path', 'stroke', Color.YELLOW_MELLOW, Color.PURPLE_MAIN)};
      `;
    return css`
      ${hoverChild('path', 'stroke', Color.YELLOW_MELLOW, Color.BLURPLE_LIGHT)};
    `;
  }}}
  a {
    ${p12};
    font-weight: 700;
    ${inlineFlex()};
    svg {
      width: 15px;
      margin-left: 8px;
    }
  }
`;

type Props = {
  theme?: LightDark,
};

const ArrowLink = ({ children, theme = LIGHT_DARK.LIGHT, className = '', ...rest }: Props & LinkProps) => (
  <Wrapper className={className} theme={theme}>
    <Link {...rest}>
      {children}
      {RightSquaredArrow}
    </Link>
  </Wrapper>
);

export default ArrowLink;
